import { defineStore } from "pinia";
export const useCampanhaStore = defineStore("campanha", {
    state: () => ({
        isSalvando: false,
        isCarregando: false,
        isValidando: false,
        campanha: {
            vitrines: [],
            novidades: [],
        },
        recaptchaSiteKey: "",
        urlTermosUso: "",
        isLoadedStep: false,
        validationErrors: [],
        bannerWidth: 0,
        bannerHeight: 0,
        valoresSugeridos: {},
    }),
    getters: {},
    actions: {
        setRecaptchaSiteKey(key) {
            this.$state.recaptchaSiteKey = key;
        },
        setUrlTermosUso(url) {
            this.$state.urlTermosUso = url;
        },
        clearValidationErrors() {
            this.$state.validationErrors = [];
        },
        addValidationError(error) {
            this.$state.validationErrors.push(error);
        },
    },
});
